export const GET_MERCHANTS_PAGINATED = gql`
    query GetMerchantsPaginated($filters: MerchantTableFiltersInput) {
        getMerchantsPaginated(filters: $filters) {
            data {
                id
                merchantAccountNumber
                applicationId
                mid
                tradingName
                partnerName
                dateAdded
                status
            }
            total
            page
            pageSize
        }
    }
`;
